module.exports = __webpack_public_path__ + "img/小龙虾.ba81be69.jpg";